import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalRedeemInsurancePageRoutingModule } from './modal-redeem-insurance-routing.module';

import { ModalRedeemInsurancePage } from './modal-redeem-insurance.page';
//Components
import { ComponentsModule } from 'src/app/components/components.module'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    MatCheckboxModule,
    MatTabsModule,
    ModalRedeemInsurancePageRoutingModule
  ],
  declarations: [ModalRedeemInsurancePage]
})
export class ModalRedeemInsurancePageModule { }
